import { module } from 'modujs';
import {gsap} from 'gsap';
import barba from '@barba/core';
import smoothscroll from 'smoothscroll-polyfill';
import Utils from '../utils/utils';
export default class extends module {
  constructor(m) {
    super(m);


    this.nav = this.el.querySelector('.secondaryNav')
    if(!this.nav){
      return;
    }
    this.sections = document.querySelector('.header--companyNav') !== undefined ? this.el.querySelectorAll('.secondaryNav-section[data-title]:not([data-title=""]') : this.el.querySelectorAll('.secondaryNav-section')
    this.primaryNav = document.querySelector('.navbar')
    this.lastPos
    this.currentPos
    this.previousItem = []
    this.sectionsPositions = []
    smoothscroll.polyfill();

    console.log("✅secondaryNav✅", document.querySelector('.header--companyNav'), this.sections)

    this.initNav()
    this.initSections()
    if(!Utils.isMobile()) {
      this.bindEvents()
    }

  }

  initSections(){
    this.sections.forEach((el,index)=>{
      //console.log(el.getBoundingClientRect())
      this.sectionsPositions.push(el.getBoundingClientRect().top)
    })
  }
  // TODO --> DETECTION CHANGEMENT DE SECTION
  bindEvents() {
    this.switchItems()
    window.addEventListener('scroll',this.onScroll.bind(this))
    this.nav.addEventListener('click', this.goToIndex)
  }

  initNav() {
    this.sections.forEach((el, index)=>{
      if(document.querySelector('.header--companyNav') &&  el.dataset.title) {
        this.nav.innerHTML +='<div class="secondaryNav-item"><span>' + el.dataset.title + '</span><div class="secondaryNav-item--border"></div></div>'

        this.items = this.el.querySelectorAll('.secondaryNav-item')
        let parent = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: 'top top',
            end: 'bottom top',
            onEnter: () => {
              this.items[index].classList.add('section-active')
            },
            onEnterBack: () => {
              this.items[index].classList.add('section-active')
            },
            onLeave:()=>{
              this.items[index].classList.remove('section-active')
            },
            onLeaveBack:()=>{
              this.items[index].classList.remove('section-active')
            }
          }
        })

      } else if(!document.querySelector('.header--companyNav') && el.innerText) {
        this.nav.innerHTML +='<div class="secondaryNav-item"><span>' + el.innerText + '</span><div class="secondaryNav-item--border"></div></div>'

        this.items = this.el.querySelectorAll('.secondaryNav-item')
        let parent = el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
        gsap.to(el, {
          scrollTrigger: {
            trigger: parent,
            start: 'top top',
            end: 'bottom top',
            onEnter: () => {
              this.items[index].classList.add('section-active')
            },
            onEnterBack: () => {
              this.items[index].classList.add('section-active')
            },
            onLeave:()=>{
              this.items[index].classList.remove('section-active')
            },
            onLeaveBack:()=>{
              this.items[index].classList.remove('section-active')
            }
          }
        })
      }      
    })
  }

  switchItems(){
    if(this.items) {
      this.items.forEach((el,i)=>{
        el.addEventListener('click',()=>{

          
          window.scrollTo({
            top: this.sectionsPositions[i] - 90,
            behavior: "smooth"
          });

          setTimeout(() => {
            // check if previous item array has an item
            if (this.previousItem.length>0){
              this.previousItem[0].classList.remove('section-active')
            }
            // clear array
            this.previousItem = []

            el.classList.add('section-active')
            this.previousItem.push(el)
          }, 600)

        })
      })
    }
  }

  onScroll(){
    this.currentPos = window.scrollY
    this.distance
    let distanceToTop = window.pageYOffset + this.primaryNav.getBoundingClientRect().top

    // check collision between primary nav bottom & secondary nav top
    if(this.nav.getBoundingClientRect().top <= this.primaryNav.getBoundingClientRect().bottom){

      this.primaryNav.style.transition = 'none'
      this.primaryNav.classList.add('hidden-nav')
      this.primaryNav.style.top = distanceToTop +'px'

    }

    // scroll up and reset primary nav styles
    if (this.primaryNav.classList.contains('hidden-nav')&& this.lastPos > this.currentPos && this.currentPos <= this.primaryNav.offsetTop){
      this.primaryNav.classList.remove('hidden-nav')
      this.primaryNav.style.top ='0px'
      this.primaryNav.style.transition = 'none'
      // reset transition on primary nav
      setTimeout(()=>{
        this.primaryNav.style.transition = '0.3s all ease'
      },400)

    }

    // check if secondary nav top <=0
    if(this.nav.getBoundingClientRect().top <=0){
      this.nav.classList.add('fixed-nav')
    }

    // scroll up and reset secondary nav styles
    if (this.nav.classList.contains('fixed-nav')&& this.lastPos > this.currentPos && this.nav.getBoundingClientRect().top <= this.primaryNav.getBoundingClientRect().bottom) {
      this.nav.classList.remove('fixed-nav')
    }

      this.lastPos = this.currentPos
  }

  goToIndex(e) {
    if(e.target.parentNode.id === "secondaryNavLogo"){
      barba.go(bulbConfig.baseUrl);
    }
  }

  destroy() {
    // destroy method
    //console.log('DESTROYED')
    window.removeEventListener('scroll',this.onScroll.bind(this))
    this.items.forEach((el,i)=>{
      el.removeEventListener('click',()=>{

        // check if previous item array has an item
        if (this.previousItem.length>0){
          this.previousItem[0].classList.remove('section-active')
        }
        // clear array
        this.previousItem = []

        el.classList.add('section-active')
        this.previousItem.push(el)

        this.sections[i].scrollIntoView({
          behavior: "smooth"
        })

      })
    })
      this.nav.removeEventListener('click', this.goToIndex)
  }

}





// WEBPACK FOOTER //
// ./scripts/modules/secondaryNav.js